<template>
	<div>
		<PageHeader
			:data="{
				name: 'Invoices',
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Clients', to: '/clients' },
					{ name: client.name, to: '/clients/edit/' + client.id },
				],
			}"
		/>
		<div class="actions d-flex justify-content-between mb-3"></div>

		<div class="card mb-3">
			<div class="card-header">
				<div class="actions d-flex justify-content-between align-items-center">
					<h3 class="p-0 m-0">🏦 Billing</h3>
					<button class="btn btn-primary" @click="fetchInvoices()">
						<font-awesome-icon v-if="loadingFetch" :icon="['fas', 'spinner']" class="fa-spin" /> Update
						Invoices from Freshbooks
					</button>
				</div>
			</div>
			<div class="card-body">
				<div class="row mb-4">
					<div class="col-md-6">
						<label class="form-label fw-bold">Freshbooks Client ID</label>
						<div class="input-group">
							<input
								type="text"
								class="form-control"
								v-model="client.freshbooks_client_id"
								placeholder="e.g. 12345"
							/>
							<button class="btn btn-primary" type="button" :disabled="savingFreshbooksId" @click="saveFreshbooksClientId">
								<font-awesome-icon :icon="['fas', savingFreshbooksId ? 'spinner' : 'save']" :class="{ 'fa-spin': savingFreshbooksId }" class="me-1" />
								Save
							</button>
						</div>
						<small class="text-muted">Korišćeno za direktnu sinhronizaciju faktura sa Freshbooks-a.</small>
					</div>
				</div>
				<div class="row">
					<div class="col-md-3 mb-4">
						<router-link
							class="text-decoration-none"
							:to="'/clients/edit/' + this.$route.params.id + '/billing/invoices'"
						>
							<div class="card menu-item-big" style="min-height:175px">
								<div class="card-body d-flex justify-content-center align-items-center flex-column">
									<h4 class="mb-3">Invoices</h4>
									<img src="../../assets/images/invoices.svg" width="90" alt="" />
								</div>
							</div>
						</router-link>
					</div>
					<div class="col-md-3 mb-4">
						<router-link
							class="text-decoration-none"
							:to="'/clients/edit/' + this.$route.params.id + '/billing/email-notifications'"
						>
							<div class="card menu-item-big" style="min-height:175px">
								<div class="card-body d-flex justify-content-center align-items-center flex-column">
									<h4 class="mb-3">Email Notifications</h4>
									<img src="../../assets/images/email-notifications.svg" width="90" alt="" />
								</div>
							</div>
						</router-link>
					</div>
					<div class="col-md-3 mb-4">
						<router-link
							class="text-decoration-none"
							:to="'/clients/edit/' + this.$route.params.id + '/billing/letter-notifications'"
						>
							<div class="card menu-item-big" style="min-height:175px">
								<div class="card-body d-flex justify-content-center align-items-center flex-column">
									<h4 class="mb-3">Letter Notifications</h4>
									<img src="../../assets/images/lob-notifications.svg" width="120" alt="" />
								</div>
							</div>
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import { handleErrors } from '../../actions/helpers'
import { Tooltip } from 'bootstrap'
import restApi from '../../api/index.js'
export default {
	name: 'ClientBilling',
	components: { PageHeader },
	data() {
		return {
			loading: false,
			loadingFetch: false,
			savingFreshbooksId: false,
			client: {
				name: '',
				freshbooks_client_id: null,
			},
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
	},
	created() {
		setTimeout(() => {
			document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
				new Tooltip(el)
			})
		}, 1100)
		this.getClient()
		this.getInvoices()
	},
	methods: {
		// Get Client
		getClient() {
			restApi
				.get(`/clients/${this.$route.params.id}`)
				.then(({ data }) => {
					this.client = data
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Fetch Invoices
		fetchInvoices() {
			this.loadingFetch = true
			restApi
				.get(`/freshbooks/invoices/fetch/${this.$route.params.id}`, { params: this.request })
				.then(({ data }) => {
					console.log(data)
					this.loadingFetch = false
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
					this.loadingFetch = false
				})
		},
		saveFreshbooksClientId() {
			if (!this.client.name || this.client.name.trim() === '') {
				this.$swal.fire({
					icon: 'error',
					title: 'Client nema validno ime',
					timer: 4000,
				})
				return
			}

			let preparedId = null
			if (this.client.freshbooks_client_id !== null && this.client.freshbooks_client_id !== '') {
				const rawValue = this.client.freshbooks_client_id.toString().trim()
				if (rawValue !== '') {
					const parsed = Number(rawValue)
					if (Number.isNaN(parsed)) {
						this.$swal.fire({
							icon: 'error',
							title: 'Freshbooks ID mora biti broj',
							timer: 4000,
						})
						return
					}
					preparedId = parsed
				}
			}

			this.savingFreshbooksId = true
			restApi
				.put(`/clients/${this.$route.params.id}`, {
					name: this.client.name,
					freshbooks_client_id: preparedId,
				})
				.then(({ data }) => {
					this.client = data
					this.$swal.fire({
						icon: 'success',
						title: 'Freshbooks ID sačuvan!',
						timer: 3000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 4000,
					})
				})
				.finally(() => {
					this.savingFreshbooksId = false
				})
		},
	},
	filters: {
		removeString: function(value) {
			if (!value) return ''
			value = value.replace('&laquo;', '')
			return value.replace('&raquo;', '')
		},
	},
}
</script>
